import { InjectionToken, Provider, REQUEST_CONTEXT, RendererFactory2, inject } from '@angular/core';
import { BEFORE_APP_SERIALIZED } from '@angular/platform-server';

import { WINDOW } from '../browser/window/window.token';

/* @internal */
export const CLIENT_CONFIG_TOKEN = new InjectionToken<{ [key: string]: any }>('CLIENT_CONFIG_TOKEN', {
    providedIn: 'root',
    factory: () => inject(WINDOW)['clientConfig'],
});

export function provideInlineClientConfig() {
    return [
        {
            provide: BEFORE_APP_SERIALIZED,
            useFactory: () => {
                const rendererFactory = inject(RendererFactory2);
                const clientConfig = inject(CLIENT_CONFIG_TOKEN);

                return () => {
                    // TODO: get rid of it when clientconfig v2 is working properly on local environment
                    // as the node env is executed before the dotnet env, we have  inline the clientconfig from here.
                    // also, right now we are overriding apiBaseUrls back-and-forth to have it somehow running
                    // this needs to be removed when clientconfig v2 is stable on local environments

                    const renderer = rendererFactory.createRenderer(null, null);

                    const script = renderer.createElement('script');
                    renderer.setAttribute(script, 'id', 'clientconfig-hack');

                    const scriptContent = `
                            const clientConfig = {...(window?.clientConfig ?? {}), ...${JSON.stringify(clientConfig)}};
                            window.clientConfig = {...clientConfig};
                        `;
                    const textNode = renderer.createText(scriptContent);
                    renderer.appendChild(script, textNode);

                    const head = renderer.selectRootElement('head', true);
                    renderer.appendChild(head, script);

                    return true;
                };
            },
            multi: true,
        },
    ];
}

export function provideClientConfig(fallbackClientConfig?: { [key: string]: any }): Provider[] {
    return [
        {
            provide: CLIENT_CONFIG_TOKEN,
            useFactory: () => {
                const requestClientConfig =
                    inject<{ clientConfig: { [key: string]: any } } | null>(REQUEST_CONTEXT)?.clientConfig ?? fallbackClientConfig ?? {};
                return Object.assign(inject(WINDOW), { clientConfig: requestClientConfig }).clientConfig;
            },
        },
    ];
}
